<!--  -->
<template>
  <div class="container">
    <div class="hint">报名人信息</div>
    <div class="content">
      <div class="item" v-for="(item,index) in formList" :key="index">
        <span class="star" v-if="item.is_must == 1">*</span>
        <span class="hide star" v-else>*</span>
        <span class="title">{{item.config_name}}</span>
        <input
          type="text"
          style="background-color:transparent"
          :placeholder="'请输入'+item.config_name"
          v-model="item.content"
          :disabled="item.config_id == 1 || item.config_id == 2 || item.config_id == 3 ||item.config_id == 4 || item.config_id ==5?true:false"
          :class="item.config_id == 14?'setWidth':''"
          v-show="(item.input_method == 1  && item.config_id != 26) || (item.input_method == 1 && item.config_id == 19) || (item.input_method == 1 && item.config_id == 6)"
        />
        <!-- <span
          class="text"
          style="color:#333"
          v-show="item.input_method == 1 && !!item.default_value == true && item.config_id != 26 && item.config_id != 19 && item.config_id != 6 && item.config_id != 14"
        >{{item.default_value}}</span> -->
        <span
          @click="select(item.config_name)"
          v-show="item.input_method == 5 && !!item.content == false"
          class="text"
        >请选择{{item.config_name}}</span>
        <span
          @click="item.config_id != 2?select(item.config_name):''"
          v-show="item.input_method == 5 && !!item.content == true "
          class="text"
          style="color:#333"
        >{{item.content}}</span>
        <van-action-sheet v-model="show" :actions="actions" cancel-text="取消" @select="onSelect" />
        <van-checkbox-group
          v-model="result"
          direction="horizontal"
          style="display:inline-block"
          v-show="item.is_multi == '1'"
        >
          <van-checkbox
            :name="i"
            v-for="(data,i) in item.dataArr"
            style="font-size:15px"
            :key="i"
          >{{data}}</van-checkbox>
        </van-checkbox-group>
        <van-checkbox-group
          v-model="item.content"
          v-show="item.is_multi == '0' && item.input_method == '4'"
        >
          <van-checkbox :name="cnt.name" v-for="(cnt,i) in item.multiple" :key="i">{{cnt.name}}</van-checkbox>
        </van-checkbox-group>
        <span
          @click="selectDate(item.config_id)"
          v-show="item.input_method == '2' && !!item.content == false"
          :class="item.config_id == 15 || item.config_id == 16?'setBWidth':'datetext'"
        >请选择{{item.config_name}}</span>
        <span
          @click="selectDate(item.config_id)"
          v-show="item.input_method == '2' && !!item.content == true && item.config_id != 15 && item.config_id != 16"
          class="text"
          style="color:#333"
        >{{item.content}}</span>

        <span @click="toAddress" v-show="item.config_id ==26 && city == ''" class="text">请选择地区</span>
        <span
          class="addItem"
          v-show="item.input_method == '1' && item.config_id == 14"
          @click="addNumber(item.numArr)"
        >添加</span>
        <span
          class="addItem"
          v-show="item.input_method == '2' && item.config_id == 15"
          @click="addGetDate(item.numArr)"
        >添加</span>
        <span
          class="addItem"
          v-show="item.input_method == '2' && item.config_id == 16"
          @click="addOverDate(item.numArr)"
        >添加</span>
        <div
          class="inputMoreNum"
          v-for="(content,i) in item.numArr"
          :key="i"
          v-if="item.input_method == '1' && item.config_id == 14"
        >
          <input
            type="text"
            class="moreNum"
            placeholder="请输入证书编号/卡号"
            style="width:140px"
            v-model="content.name"
          />
          <span class="jianhao" @click="deleteItem(item,content,i)">删除</span>
        </div>
        <div
          class="selectGetDate"
          v-for="(content,i) in item.numArr"
          :key="i"
          v-if="item.input_method == '2' && item.config_id == 15"
        >
          <span
            v-if="content.name == ''"
            @click="selectDate(item.config_id,content)"
            class="text"
          >请选择{{item.config_name}}</span>
          <span
            @click="selectDate(item.config_id,content)"
            v-else
            class="text"
            style="color:#333"
          >{{content.name}}</span>
          <span class="jianhao" @click="deleteDate(item,content,i)">删除</span>
        </div>
        <div
          class="selectGetDate"
          v-for="(content,i) in item.numArr"
          :key="i"
          v-if="item.input_method == '2' && item.config_id == 16"
        >
          <span
            v-if="content.name == ''"
            @click="selectDate(item.config_id,content)"
            class="text"
          >请选择{{item.config_name}}</span>
          <span
            @click="selectDate(item.config_id,content)"
            v-else
            class="text"
            style="color:#333"
          >{{content.name}}</span>
          <span class="jianhao" @click="deleteOverDate(item,content,i)">删除</span>
        </div>
        <div
          @click="toAddress"
          v-show="item.config_id ==26 && city != ''"
          class="text"
          style="color:#333;vertical-align: top;"
        >{{city}}</div>
        <div
          v-show="item.config_id ==26 && city != ''"
          class="text"
          style="color:#333;margin-left:120px;vertical-align: top;"
        >
          <input type="text" placeholder="请填写详细地址" v-model="city2" />
        </div>
        <v-distpicker type="mobile" v-show="addInp" @selected="selected" class="area1">{{city}}</v-distpicker>
      </div>
      <div class="item" v-show="city != ''">
        <span class="title" style="width:100px;display:inline-block;margin-left:10px">家庭地址</span>
      </div>
    </div>
    <div class="mask" v-show="mask" @click="closeMask"></div>
    <button class="enter" @click="ok">确定</button>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Dialog, Toast } from "vant";
import VDistpicker from "v-distpicker";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    VDistpicker
  },
  data() {
    //这里存放数据
    return {
      course_id: null,
      plan_id: null,
      work_type: null,
      formList: [],
      actions: [],
      show: false,
      result: [],
      selectArr: [],
      resultList: [],
      showDate: false,
      currentdate: "",
      dateArr: [],
      addInp: false,
      mask: false,
      city: "",
      city2: "",
      allAddress: "",
      moreNumber: "",
      numberInfo: [],
      numberIndex: 0,
      getDateIndex: 0,
      overDateIndex: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 获取表单
    getForm() {
      this.$http.getCourseConfig({ course_id: this.course_id }).then(res => {
        if (res.status == 1) {
          let data = res.data;
          for (let index = 0; index < data.length; index++) {
            if (data[index].extra_select) {
              let arr = data[index].extra_select.split(",");
              data[index].dataArr = arr;
            }
            if ( data[index].input_method == "5" && data[index].extra_select != "") {
              data[index].selectArr = [];
              for (let i = 0; i < data[index].dataArr.length; i++) {
                data[index].selectArr.push({
                  name: data[index].dataArr[i],
                  color: "#7a7a7a",
                  id: data[index].config_id
                });
              }
            } else if (data[index].input_method == "4" &&data[index].is_multi == "0") {
              data[index].multiple = [];
              data[index].content = []
              for (let i = 0; i < data[index].dataArr.length; i++) {
                data[index].multiple.push({
                  name: data[index].dataArr[i],
                  id: data[index].config_id
                });
              }
              this.resultList[0] = data[index].config_id;

            } else if (data[index].input_method == "2") {
              data[index].content = "";
            }
            if (data[index].default_value && data[index].input_method != '4') {
              data[index].content = data[index].default_value;
            }
            if (data[index].default_value && (data[index].config_id == 14 || data[index].config_id == 15 || data[index].config_id == 16)) {
              data[index].numArr = []
              let carNumberArr = data[index].default_value.split(',')
              for (let i = 0; i < carNumberArr.length; i++) {
                data[index].numArr.push({
                  name:carNumberArr[i],
                  index:i
                })
              }
            }
            if (
              data[index].input_method == "2" && (data[index].config_id == 15 || data[index].config_id == 16) || data[index].input_method == "1" && data[index].config_id == 14
            ) {
              data[index].numArr = [];
            }
          }
          this.formList = data;
        }
      });
    },
    select(name) {
      for (let index = 0; index < this.formList.length; index++) {
        if (this.formList[index].config_name == name) {
          this.actions = this.formList[index].selectArr;
        }
      }
      this.show = true;
    },
    selectDate(id, content) {

      // this.showDate = true;
      this.$picker.show({
        type: "datePicker",
        date: this.currentdate,
        endTime: "2025-01-01", //截至时间
        startTime: "2000-01-01", //开始时间
        onOk: date => {
          // this.dateArr.push({
          //   id,
          //   date,
          // })
          if (content != undefined) {
            content.name = date;
          } else {
            for (let index = 0; index < this.formList.length; index++) {
              if (id == this.formList[index].config_id) {
                this.formList[index].content = date;
              }
            }
          }
        }
      });
    },
    // 选择时间的取消
    startTimeCancelDate() {},
    onSelect(e) {
      this.selectArr.push({
        config_id: e.id,
        config_value: e.name
      });
      for (let index = 0; index < this.formList.length; index++) {
        for (let i = 0; i < this.selectArr.length; i++) {
          if (this.formList[index].config_id == this.selectArr[i].config_id) {
            this.formList[index].content = this.selectArr[i].config_value;
          }
        }
      }
      this.show = false;
    },
    toAddress() {
      this.mask = true;
      this.addInp = true;
    },
    // 省市区三级联动
    selected(data) {
      this.mask = false;
      this.addInp = false;
      this.city =
        data.province.value + " " + data.city.value + " " + data.area.value;
    },
    // 新增证书编号/卡号
    addNumber(arr) {
      this.numberIndex++;
      arr.push({
        index: this.numberIndex,
        name: ""
      });
    },
    // 新增初次领证日期
    addGetDate(arr) {
      this.getDateIndex++;
      arr.push({
        index: this.getDateIndex,
        name: ""
      });
    },
    // 新增到期领证日期
    addOverDate(arr) {
      this.overDateIndex++;
      arr.push({
        index: this.overDateIndex,
        name: ""
      });
    },
    // 删除证书编号/卡号
    deleteItem(item, obj,index) {
      item.numArr.splice(index, 1);
    },
    // 删除初次领证日期
    deleteDate(item, obj,index){
      item.numArr.splice(index, 1);
    },
    // 删除到期领证日期
    deleteOverDate(item, obj,index){
      item.numArr.splice(index, 1);
    },
    // 关闭遮罩层
    closeMask() {
      this.addInp = false;
      this.mask = false;
    },
    ok() {
      let arr = [];
      let numArr = [];
      let numStr = "";
      let getDateArr = [];
      let getDateStr = "";
      let overDateArr = [];
      let overDateStr = "";
      for (let index = 0; index < this.formList.length; index++) {
        let data = this.formList[index]
        if ((data.content instanceof Array == false && data.config_id != 14) && (data.content instanceof Array == false &&data.config_id != 15) && (data.content instanceof Array == false &&data.config_id != 16)) {
          arr.push({
            config_id: data.config_id,
            config_value: data.content || ""
          });
        } else if ((data.content instanceof Array == true &&data.config_id != 14) && (data.content instanceof Array == true &&data.config_id != 15) && (data.content instanceof Array == true &&data.config_id != 16)) {
          let str = data.content.join(",");
          arr.push({
            config_id: data.config_id,
            config_value: str || ""
          });
        }
        if (data.numArr && data.config_id == 14) {
          if(data.numArr.length != 0){
            for (let i = 0; i < data.numArr.length; i++) {
              numArr.push(data.numArr[i].name);
              numStr = numArr.join(",");
            }
            let allNumStr = data.content + "," + numStr;
            arr.push({
              config_id: data.config_id,
              config_value: allNumStr
            });
          }

        } else if (data.numArr &&data.config_id == 15) {
          if(data.numArr.length != 0){
            for (let i = 0; i < data.numArr.length; i++) {
              getDateArr.push(data.numArr[i].name);
              getDateStr = getDateArr.join(",");
            }
            let allGDateStr = data.content + "," + getDateStr;
            arr.push({
              config_id: data.config_id,
              config_value: allGDateStr
            });
          }

        }else if (data.numArr &&data.config_id == 16) {
          if(data.numArr.length != 0){
            for (let i = 0; i < data.numArr.length; i++) {
              overDateArr.push(data.numArr[i].name);
              overDateStr = overDateArr.join(",");
            }
            let allODateStr = data.content + "," + overDateStr;
            arr.push({
              config_id: data.config_id,
              config_value: allODateStr
            });
          }

        }
      }
      if (this.city != "") {
        arr.push({
          config_id: 26,
          config_value: this.city2
        });
      }
      this.$http
        .submitSignFrom({
          plan_id: this.plan_id,
          format: JSON.stringify(arr)
        })
        .then(res => {
          if (res.status == 1) {
            Dialog.alert({
              title: "提示",
              message: res.msg
            }).then(() => {
              this.$router.push({
                path: "/uploadingApplyData",
                query: {
                  id: this.plan_id,
                  course_id: this.course_id,
                  work_type: this.type
                }
              });
            });
          } else {
            Toast(res.msg);
          }
        });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let course_id = this.$route.query.course_id;
    let id = this.$route.query.id;
    let workType = this.$route.work_type;
    this.course_id = course_id;
    this.plan_id = id;
    this.work_type = workType;
    this.getForm();

    // 当前时间
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    this.currentdate = year + seperator1 + month + seperator1 + strDate;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {
    // let arr = [];
    // for (let index = 0; index < this.formList.length; index++) {
    //   if (this.formList[index].content instanceof Array == false) {
    //     if (this.formList[index].default_value) {
    //       arr.push({
    //         config_id: this.formList[index].config_id,
    //         config_value: this.formList[index].default_value
    //       });
    //     } else {
    //       arr.push({
    //         config_id: this.formList[index].config_id,
    //         config_value: this.formList[index].content || ""
    //       });
    //     }
    //   } else if (this.formList[index].content instanceof Array == true) {
    //     let str = this.formList[index].content.join(",");
    //     arr.push({
    //       config_id: this.formList[index].config_id,
    //       config_value: str || ""
    //     });
    //   }
    // }
    // if (this.city != "") {
    //   arr.push({
    //     config_id: 26,
    //     config_value: this.city2
    //   });
    // }
    // this.$http
    //   .submitSignFrom({
    //     plan_id: this.plan_id,
    //     format: JSON.stringify(arr)
    //   })
    //   .then(res => {});
  }, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  padding: 0 10px;
  box-sizing: border-box;
  // touch-action: none;
  .hint {
    font-size: 13px;
    color: #666666;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .content {
    width: 100%;
    background-color: #fff;
    padding: 10px 10px;
    box-sizing: border-box;

    .item {
      line-height: 30px;
      // display: flex;
      .star {
        color: red;
        font-size: 15px;
        margin-right: 5px;
      }
      .hide {
        opacity: 0;
      }
      .title {
        font-size: 15px;
        color: #333;
        display: inline-block;
        // width: 100px;
        max-width: 100px;
      }
      input {
        display: inline-block;
        height: 20px;
        font-size: 15px;
        // vertical-align: center;
        border: none;
        margin-left: 20px;
        color: #333;
        // flex: 1;
      }
      .text {
        margin-left: 28px;
        color: #757575;
        font-size: 15px;
        display: inline-block;
        // flex: 1;
      }
    }
  }
  .enter {
    width: 80%;
    height: 44px;
    background-color: #0e88f7;
    border: none;
    color: #ffffff;
    border-radius: 22px;
    font-size: 17px;
    display: block;
    text-align: center;
    line-height: 44px;
    margin: 40px auto;
  }
}
/deep/ .van-overlay {
  z-index: 999 !important;
}
/deep/.van-checkbox {
  display: inline-block;
  margin-right: 10px;
}
/deep/ .van-checkbox__icon {
  display: inline-block;
  vertical-align: top;
}
/deep/ .van-checkbox__label {
  vertical-align: top;
}
/deep/ .van-icon-success,
/deep/.van-checkbox__label {
  font-size: 14px !important;
}
/deep/ .van-checkbox-group {
  padding: 5px 0 0 30px;
  box-sizing: border-box;
}
li {
  list-style: none;
}
.area1 {
  width: 100%;
  height: 45%;
  position: fixed;
  left: 0;
  bottom: 0;
  overflow-y: scroll;
  z-index: 999;
}
.distpicker-address-wrapper .address-header ul {
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
}
.mask {
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
.van-checkbox-group {
  display: inline-block;
}
.setWidth {
  width: 140px;
}
.setBWidth{
  width: 160px;
  color: #757575;
  font-size: 15px;
  display: inline-block;
}
.addItem {
  font-size: 12px;
  float: right;
  color: #0e88f7;
}
.inputMoreNum {
  margin-left: 105px;
  .jianhao {
    font-size: 12px;
    float: right;
    color: red;
  }
}
.selectGetDate {
  margin-left: 105px;
  .jianhao {
    font-size: 12px;
    float: right;
    color: red;
  }
}
.datetext{
  font-size: 15px;
  color: #757575;
  margin-left: 60px;
}
</style>
